import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import { IsLoadingService } from '@service-work/is-loading';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  isLoading: Observable<boolean>;

  constructor(
    private isLoadingService: IsLoadingService,
    private router: Router,
  ) { }

  private static readonly CHUNK_RELOAD_KEY = 'chunk_reload';

  ngOnInit() {
    // Limpa flag de reload se a página carregou com sucesso após um ChunkLoadError
    const reloadedUrl = sessionStorage.getItem(AppComponent.CHUNK_RELOAD_KEY);
    if (reloadedUrl) {
      sessionStorage.removeItem(AppComponent.CHUNK_RELOAD_KEY);
    }

    // Note, because `IsLoadingService#isLoading$()` returns
    // a new observable each time it is called, it shouldn't
    // be called directly inside a component template.
    this.isLoading = this.isLoadingService.isLoading$();

    this.router.events
      .pipe(
        filter(
          event =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError,
        ),
      )
      .subscribe(event => {

        // Reload automático ao falhar carregamento de chunk (deploy com hashes novos)
        if (event instanceof NavigationError && event.error?.name === 'ChunkLoadError') {
          const lastReload = sessionStorage.getItem(AppComponent.CHUNK_RELOAD_KEY);
          if (lastReload !== event.url) {
            sessionStorage.setItem(AppComponent.CHUNK_RELOAD_KEY, event.url);
            window.location.reload();
          }
          return;
        }

        // Google Analytics
        if (event instanceof NavigationEnd) {
          const fn = (<any>window).gtag;
          // Verifica se o Analytics foi configurado antes de tentar enviar dados
          if (fn) {
            fn('set', 'page', event.urlAfterRedirects);
            fn('send', 'pageview');
          }
          // console.log('NavigationEnd', fn, event);
        }

        // If it's the start of navigation, `add()` a loading indicator
        if (event instanceof NavigationStart) {
          this.isLoadingService.add();
          return;
        }

        // Else navigation has ended, so `remove()` a loading indicator
        this.isLoadingService.remove();
      });
  }


}
